import type { LeaderboardRow } from '@/models'

import { PLAYERS } from './players'

const CLANS = [
  'Ashfall',
  'Iron Tide',
  'Nine Lanterns',
  'Salt & Cinder',
  'Verdant Maw',
  'Low Orbit',
  'Paper Tigers',
]

export const LEADERBOARD: LeaderboardRow[] = [...PLAYERS]
  .sort((a, b) => b.trophies - a.trophies)
  .slice(0, 40)
  .map((player, i) => ({
    id: player.id,
    rank: i + 1,
    username: player.username,
    clan: CLANS[i % CLANS.length],
    trophies: player.trophies,
    winRate: Math.round((player.wins / (player.wins + player.losses)) * 1000) / 10,
  }))
